import { registerPlugin, type PluginListenerHandle } from '@capacitor/core'

/**
 * Custom Capacitor plugin: fires `screenshotTaken` right after the user takes
 * an OS screenshot inside the app.
 *
 * We can't inject the app version INTO the OS screenshot (the OS captures the
 * already-rendered frame, and the detection callback fires after capture). So
 * instead we use the screenshot as a trigger: when it fires, the app surfaces
 * its version so the tester can copy it into the /tester feedback form.
 *
 * Native implementations:
 *   iOS     → UIApplication.userDidTakeScreenshotNotification  (all versions)
 *   Android → Activity.registerScreenCaptureCallback           (API 34+ only)
 *
 * No web implementation — on the browser the listener simply never fires.
 */
export interface ScreenshotDetectorPlugin {
  addListener(
    eventName: 'screenshotTaken',
    listenerFunc: () => void,
  ): Promise<PluginListenerHandle> & PluginListenerHandle
  removeAllListeners(): Promise<void>
}

export const ScreenshotDetector = registerPlugin<ScreenshotDetectorPlugin>('ScreenshotDetector')
